/** @format */

import React, { useEffect, useMemo, useState } from 'react'
import * as Styles from './style'
import { useTable, useSortBy, usePagination } from 'react-table'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import Cookies from 'universal-cookie'
import { Input } from 'antd'
import CreateCLFForm from './components/ClfForm/ClfForm'

const cookies = new Cookies()

const CLFs = () => {
  const [clfs, setClfs] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [blocks, setBlocks] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedBlock, setSelectedBlock] = useState('')
  const [search, setSearch] = useState('')
  const [filteredClfs, setFilteredClfs] = useState([])
  const [voMap, setVoMap] = useState({}) // { clfId: [vo1, vo2, ...] }
  const [shgs, setShgs] = useState([])
  const [loading, setLoading] = useState(false)

  const [showClfModal, setShowClfModal] = useState(false)

  const token = cookies.get('access_token')

  // Fetch states
  const fetchStates = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + '/api/v1/location/states',
        { headers: { Authorization: 'Bearer ' + token } }
      )
      setStates(res.data)
    } catch (err) {
      console.error('Error fetching states', err)
    }
  }

  // Fetch districts based on state
  const fetchDistricts = async state => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
          '/api/v1/location/districts?states=' +
          state,
        { headers: { Authorization: 'Bearer ' + token } }
      )
      setDistricts(res.data)
    } catch (err) {
      console.error('Error fetching districts', err)
    }
  }

  // Fetch blocks based on district
  const fetchBlocks = async district => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + `/api/v1/humblebee/blocks/${district}`,
        {
          headers: { Authorization: 'Bearer ' + token },
          source: 'humblebee_admin',
        }
      )
      setBlocks(res.data)
    } catch (err) {
      console.error('Error fetching blocks', err)
    }
  }

  // Fetch CLFs based on block
  const fetchClfs = async blockId => {
    try {
      setLoading(true)
      const res = await axios.get(
        process.env.REACT_APP_API_URL + `/api/v1/humblebee/clf/all`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
            source: 'humblebee_admin',
          },
        }
      )
      setClfs(res.data?.data || [])
      setFilteredClfs(res.data?.data || [])
      // fetchVosForClfs(res.data?.data || [])
      setLoading(false)
    } catch (err) {
      console.error('Error fetching CLFs', err)
    }
  }

  const fetchVosForClfs = async clfs => {
    console.log('fetchVosForClfs called with CLFs:', clfs)
    try {
      const voData = {}

      await Promise.all(
        clfs.map(async clf => {
          try {
            console.log('Fetching VOs for CLF:', clf._id)
            const res = await axios.get(
              `${process.env.REACT_APP_API_URL}/api/v1/humblebee/clf/vos/all?clfId=${clf._id}`,
              {
                headers: {
                  Authorization: 'Bearer ' + token,
                  source: 'humblebee_admin',
                },
              }
            )
            voData[clf._id] = res.data?.data || []
            console.log('Fetched VO for', clf._id, ':', voData[clf._id])
          } catch (err) {
            console.error('Error fetching VOs for CLF:', clf._id, err)
          }
        })
      )

      console.log('VO Data Map after fetch:', voData)
      setVoMap(voData)
    } catch (err) {
      console.error('Error in fetchVosForClfs:', err)
    }
  }

  useEffect(() => {
    const query = search.toLowerCase()
    setFilteredClfs(
      clfs.filter(
        clf =>
          clf.name?.toLowerCase().includes(query) ||
          clf.email?.toLowerCase().includes(query) ||
          clf.mobileNumber?.toLowerCase().includes(query)
      )
    )
  }, [search, clfs])

  useEffect(() => {
    fetchStates()
  }, [])

  useEffect(() => {
    if (selectedState) fetchDistricts(selectedState)
  }, [selectedState])

  useEffect(() => {
    if (selectedDistrict) fetchBlocks(selectedDistrict)
  }, [selectedDistrict])

  useEffect(() => {
    fetchClfs(selectedBlock)
  }, [selectedBlock])

  const CLF_COLUMNS = [
    { Header: 'CLF Name', accessor: 'name' },
    // {
    //   Header: 'Chairman',
    //   accessor: 'chairman',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    // {
    //   Header: 'Secretary',
    //   accessor: 'secretary',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    // {
    //   Header: 'Treasurer',
    //   accessor: 'treasurer',
    //   Cell: ({ value }) => value?.name || '-',
    // },
    {
      Header: 'State',
      accessor: 'location.block.state',
      Cell: ({ row }) => row.original?.location?.block?.state || '-',
    },
    {
      Header: 'District',
      accessor: 'location.block.district',
      Cell: ({ row }) => row.original?.location?.block?.district || '-',
    },
    {
      Header: 'Block',
      accessor: 'location.block.name',
      Cell: ({ row }) => row.original?.location?.block?.name || '-',
    },
    {
      Header: 'VOs',
      accessor: 'vos',
      Cell: ({ row }) => {
        const clfId = row.original?._id
        const clfName = row.original?.name || ''
        const voCount = voMap[clfId]?.length || 0
        return (
          <span>
              <span className="text-blue-500 cursor-pointer ml-2">
              <a href={`/clfs/vos?clfId=${clfId}&clfName=${clfName}`}>
              View VOs
                </a>
              </span>
          </span>
        )
      },
    },
  ]

  const columns = useMemo(() => CLF_COLUMNS, [voMap])
  const data = useMemo(() => {
    if (!search.trim()) return clfs
    return clfs.filter(
      clf =>
        clf.name?.toLowerCase().includes(search.toLowerCase()) ||
        clf.location?.block?.name?.toLowerCase().includes(search.toLowerCase())
    )
  }, [clfs, search])

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 1000 },
    },
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
  } = tableInstance
  const { pageIndex, pageSize } = state

  if (loading) {
    return  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <h1 style={{ fontSize: 32, color: '#ff8701', margin: 0 }}>Loading.... </h1>
    </div>
  }

  const findClfByDistrict = clfs => {
    const districtCount = {}

    clfs.forEach(clf => {
      const district = clf.location?.block?.district || 'Unknown'
      if (districtCount[district]) {
        districtCount[district] += 1
      } else {
        districtCount[district] = 1
      }
    })

    return Object.entries(districtCount).map(([district, count]) => (
      <span key={district}>
        {district}: {count} ||{' '}
      </span>
    ))
  }

  return (
    <>
      <Styles.SupplierBox>
        <div className="flex gap-4 mb-4">
          <h3 className="text-2xl font-semibold mb-4">
            Community Leaders (CLFs)
          </h3>
          <Button
            variant="primary"
            onClick={() => setShowClfModal(true)}
            style={{ marginBottom: '20px', cursor: 'pointer' }}
          >
            + Create CLF
          </Button>
          <CreateCLFForm
            showClfModal={showClfModal}
            setShowClfModal={setShowClfModal}
            onSuccess={fetchClfs}
          />

          {/* Search input */}
          <Input
            type="text"
            placeholder="Search CLFs by name, block..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="mb-6"
          />
          <p className="text-gray-600 self-center mt-4 gap-2">
            Total CLFs: {filteredClfs?.length}{' '}
            {/* Total VOs: {vos?.length} {" "}
          Total SHGs: {shgs?.length} */}
          </p>
          <p className="text-gray-600 self-center mt-2 gap-2">
            {findClfByDistrict(filteredClfs)}
          </p>
          {/* State dropdown */}
          {/* <select
          value={selectedState}
          onChange={e => {
            setSelectedState(e.target.value)
            setSelectedDistrict('')
            setSelectedBlock('')
          }}
          className="border p-2 rounded"
        >
          <option value="">Select State</option>
          {states.map(s => (
            <option key={s._id} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>

        <select
          value={selectedDistrict}
          onChange={e => {
            setSelectedDistrict(e.target.value)
            setSelectedBlock('')
          }}
          className="border p-2 rounded"
          disabled={!selectedState}
        >
          <option value="">Select District</option>
          {districts.map(d => (
            <option key={d._id} value={d.name}>
              {d.name}
            </option>
          ))}
        </select> */}

          {/* Block dropdown */}
          {/* <select
          value={selectedBlock}
          onChange={e => setSelectedBlock(e.target.value)}
          className="border p-2 rounded"
          disabled={!selectedDistrict}
        >
          <option value="">Select Block</option>
          {blocks.map(b => (
            <option key={b._id} value={b._id}>
              {b.name}
            </option>
          ))}
        </select> */}
        </div>

        <Styles.TableContainer>
          <Styles.Table {...getTableProps()}>
            <Styles.THead>
              {headerGroups.map(headerGroup => (
                <Styles.THeadRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(headerColumn => (
                    <Styles.TH
                      {...headerColumn.getHeaderProps(
                        headerColumn.getSortByToggleProps()
                      )}
                    >
                      {headerColumn.render('Header')}
                    </Styles.TH>
                  ))}
                </Styles.THeadRow>
              ))}
            </Styles.THead>

            <Styles.TBody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Styles.TBodyRow {...row.getRowProps()}>
                    {row.cells.map((cell, i) => (
                      <Styles.TD key={i}>{cell.render('Cell')}</Styles.TD>
                    ))}
                  </Styles.TBodyRow>
                )
              })}
            </Styles.TBody>
          </Styles.Table>
        </Styles.TableContainer>

        <Styles.PaginationmainContainer>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span>
              <strong>
                Page {pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
            <select
              value={pageSize}
              onChange={e => {
                setPageSize(Number(e.target.value))
              }}
              style={{
                padding: '5px 10px',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              {[100, 500, 1000, 2000, 3000, 5000].map(pageSizeOption => (
                <option key={pageSizeOption} value={pageSizeOption}>
                  Show {pageSizeOption}
                </option>
              ))}
            </select>
          </div>
          <Styles.PaginationDiv>
            <Styles.PaginationButton
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {'<<'}
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </Styles.PaginationButton>
            <Styles.PaginationButton onClick={nextPage} disabled={!canNextPage}>
              Next
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {'>>'}
            </Styles.PaginationButton>
          </Styles.PaginationDiv>
        </Styles.PaginationmainContainer>
      </Styles.SupplierBox>
    </>
  )
}

export default CLFs
